import React, { Component } from 'react';
import { Button, Input, Checkbox, Form, Modal, Image, Header,Segment,Grid,Message,Icon} from 'semantic-ui-react'

import axios from 'axios'
import ReactModalLogin from "react-modal-login";
import styles from '../navbar/navbar';
import './signin.scss';


class Signin extends Component {
    constructor() {
        super();

        this.state = {

            showSigninModal: false,
            showSignupModal: false,
            loading: false,
            error: null,
            data: '',
            user: '',
            userNameUniqueError: '',
            emailUniqueError:'',
            userNameWrongError:'',
            passwordWrongError:'',
            userNameEmpty:'',
            userPasswordEmpty:'',
            userEmailEmpty:''
        };
        this.onLoginSuccess = this.onLoginSuccess.bind(this);
        this.onRegister = this.onRegister.bind(this);
        this.onLogin = this.onLogin.bind(this)
    }

    onLogin() {
        console.log('__onLogin__');
        console.log('username: ' + document.querySelector('#username').value);
        console.log('password: ' + document.querySelector('#password').value);

        const username = document.querySelector('#username').value;
        const password = document.querySelector('#password').value;

        if(username){
            this.setState({
                userNameEmpty: ''
            })
        }
        if(password){
             this.setState({
                userPasswordEmpty: ''
            })
        }

        if (!username || !password) {
            this.setState({
                error: true
            })
            if(!username){
                this.setState({
                    userNameEmpty: <Message negative color='orange'>
                                     <Message.Header>Username cannot be empty!</Message.Header>
                                        </Message>
                })
            }
            if(!password){
                this.setState({
                    userPasswordEmpty: <Message negative color='orange'>
                                     <Message.Header>Password cannot be empty!</Message.Header>
                                        </Message>
                })
            }

        } else {

            // Form the URL  POST username and passwor; get a token and a user id
            let url = `http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/login`;
            console.log(url);

            axios.post(url, { username, password }).then((response) => {

                console.log(response);
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.user));
                window.location = `${process.env.PUBLIC_URL}/`;
            }).catch((error) => {
                // console.log(error.toString());
                console.error("%O", error)
                this.handleError(error);
            });
        }
    }

    onRegister() {
        console.log('__onRegister__');
        console.log('username: ' + document.querySelector('#username').value);
        console.log('email: ' + document.querySelector('#email').value);
        console.log('password: ' + document.querySelector('#password').value);

        const username = document.querySelector('#username').value;
        const email = document.querySelector('#email').value;
        const password = document.querySelector('#password').value;


        if(username){
            this.setState({
                userNameEmpty: ''
            })
        }
        if(email){
            this.setState({
                userEmailEmpty: ''
            })
        }
        if(password){
             this.setState({
                userPasswordEmpty: ''
            })
        }



        if (!username || !email || !password) {
            this.setState({
                error: true
            })
            if(!username){
                this.setState({
                    userNameEmpty: <Message negative color='orange'>
                                     <Message.Header>Username cannot be empty!</Message.Header>
                                        </Message>,
                })
            }
            if(!email){
                this.setState({
                    userEmailEmpty: <Message negative color='orange'>
                                     <Message.Header>Email cannot be empty!</Message.Header>
                                        </Message>,
                })
            }
            if(!password){
                this.setState({
                    userPasswordEmpty: <Message negative color='orange'>
                                     <Message.Header>Password cannot be empty!</Message.Header>
                                        </Message>,
                })
            }

        } else {
            // Form the URL  POST email and passwor; get a token and a user id
            let url = `http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/users`;

            axios.post(url, { username, password, email }).then((response) => {
                console.log(response);
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.user));
                console.log(response.data.token);
                console.log(JSON.stringify(response.data.user));
                // localStorage.setItem('userId', response.userId);
                window.location = `${process.env.PUBLIC_URL}/`;
            }).catch((error) => {
                console.error("%O", error)
                console.log(error.response.data.errmsg);
                this.handleError(error);
                

            });
        }
    }
    handleError = (error)=>{
        // error code, error character
        if(error.response.data.error!=undefined){
            let code = error.response.data.error.code
            let msg = error.response.data.error.errmsg
            //duplicate
            if(code==11000){
                if(msg.includes('username')){
                    this.setState({
                        userNameUniqueError: <Message negative>
                                     <Message.Header>Username has been used</Message.Header>
                                        </Message>,
                        emailUniqueError:''
                    })
                }
                if(msg.includes('email')){
                    this.setState({
                        emailUniqueError: <Message negative>
                                     <Message.Header>Email has been used</Message.Header>
                                        </Message>,
                        userNameUniqueError:''
                    })
                }
            }

        }else{
            if(error.response.data.message=='Wrong password!'){
                this.setState({
                        passwordWrongError: <Message negative>
                                     <Message.Header>Password is wrong!</Message.Header>
                                        </Message>,
                        userNameWrongError:''
                })
            }else if(error.response.data.message=='User not found!'){
                this.setState({
                        userNameWrongError: <Message negative>
                                     <Message.Header>Username isn't exist!</Message.Header>
                                        </Message>,
                        passwordWrongError:''
                })
            }
        }
        
    }
    openSigninModal() {

        this.setState({
            showSigninModal: true
        });
    }
    openSignupModal() {
        this.setState({
            showSignupModal: true
        });
    }

    closeModal() {
        this.setState({
            showSigninModal: false,
            showSignupModal: false,
            error: null
        });
    }

    onLoginSuccess(method, response) {
        console.log("logged successfully with " + method);
        this.closeModal();
    }

    onLoginFail(method, response) {
        console.log("logging failed with " + method);
        this.setState({
            error: response
        });
    }

    startLoading() {
        this.setState({
            loading: true
        });
    }

    finishLoading() {
        this.setState({
            loading: false
        });
    }

    afterTabsChange() {
        this.setState({
            error: null
        });
    }

    render() {


        return (

            <div>

                <Modal size="tiny" trigger={<button
                    className="navbar-button"
                    open = {this.state.showSigninModal}
                    onClick={() => this.openSigninModal()}
                >SIGN IN</button>}>
                    <Modal.Header><Icon name='home' />Sign in</Modal.Header>
                    <Modal.Content>
                        {/* <div className='searchBackground'> */}

                            <Form error className='searchForm'>
                                <Segment stacked>
                                <Form.Input id='username' fluid icon='user circle' iconPosition='left' placeholder='Username' />
                                {this.state.userNameWrongError}
                                {this.state.userNameEmpty}
                                <Form.Input id='password' fluid icon='lock' iconPosition='left' placeholder='Password' type='password'/>
                                {this.state.passwordWrongError}
                                {this.state.userPasswordEmpty}
                                <Button color='blue' fluid type='submit' className="home-submit-btn" onClick={this.onLogin}>Submit</Button>
                                </Segment>
                            </Form>
                        {/* </div> */}
                    </Modal.Content>
                </Modal>

                <Modal size="tiny" trigger={<button
                    className="navbar-button"
                    onClick={() => this.openSignupModal()}
                >SIGN UP</button>}>
                    <Modal.Header className="centered"><Icon name='home' />Sign up</Modal.Header>
                    <Modal.Content>
                        <Form error className='searchForm'>
                            <Segment stacked>
                                <Form.Input id='username' fluid icon='user circle' iconPosition='left' placeholder='Username' />
                                {this.state.userNameUniqueError}
                                {this.state.userNameEmpty}
                                <Form.Input id='email' fluid icon='user' iconPosition='left' placeholder='E-mail address' />
                                {this.state.emailUniqueError}
                                {this.state.userEmailEmpty}
                                <Form.Input id='password' fluid icon='lock' iconPosition='left' placeholder='Password' type='password'/>
                                {this.state.userPasswordEmpty}
                                <Button color='blue' fluid size='large' type='submit' className="home-submit-btn" onClick={this.onRegister}>Submit</Button>
                            </Segment>
                        </Form>
                    </Modal.Content>
                </Modal>


            </div>

        )
    }

}

export default Signin
